module.exports = __webpack_public_path__ + "static/Digital-Experiences-cb4b7e1b1b5b87d03b4771a5a90c8fd8.png";